class Map {
	constructor(element) {
		this.element = element;
		this.map = null;
		this.mapMarkers = [];
	}

	readMarkers() {
		this.element.querySelectorAll('.google-map-marker').forEach((markerElement) => {
			const lat = Object.prototype.hasOwnProperty.call(markerElement.dataset, 'lat')
				? markerElement.dataset.lat
				: 0;
			const lng = Object.prototype.hasOwnProperty.call(markerElement.dataset, 'lng')
				? markerElement.dataset.lng
				: 0;
			const icon = Object.prototype.hasOwnProperty.call(markerElement.dataset, 'icon')
				? markerElement.dataset.icon
				: '';

			let iconOption = {
				url: icon,
				size: new google.maps.Size(30, 30),
				scaledSize: new google.maps.Size(30, 30),
				anchor: new google.maps.Point(15, 30),
			};

			if (window.innerWidth >= 640 && document.body.classList.contains('page-template-contact')) {
				iconOption = {
					url: icon,
					size: new google.maps.Size(60, 60),
					scaledSize: new google.maps.Size(60, 60),
					anchor: new google.maps.Point(30, 60),
				};
			}

			this.mapMarkers.push({
				lat: parseFloat(lat),
				lng: parseFloat(lng),
				icon: iconOption,
			});

			markerElement.remove();
		});
	}

	createMap() {
		const mapArgs = {
			zoom: parseInt(
				Object.prototype.hasOwnProperty.call(this.element.dataset, 'zoom') ? this.element.dataset.zoom : 14
			),
			mapTypeId: window.google.maps.MapTypeId.ROADMAP,
			mapTypeControl: false,
			draggable: true,
			disableDefaultUI: true,
			fullscreenControl: false,
			tyles: [
				{
					featureType: 'administrative.neighborhood',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'landscape.man_made',
					elementType: 'geometry.fill',
					stylers: [
						{
							color: '#e8eaed',
						},
					],
				},
				{
					featureType: 'landscape.natural',
					elementType: 'geometry.fill',
					stylers: [
						{
							color: '#c1e0c8',
						},
					],
				},
				{
					featureType: 'poi',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road.arterial',
					elementType: 'geometry.fill',
					stylers: [
						{
							color: '#ffffff',
						},
					],
				},
				{
					featureType: 'road.arterial',
					elementType: 'geometry.stroke',
					stylers: [
						{
							color: '#ffffff',
						},
					],
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry.fill',
					stylers: [
						{
							color: '#fdefc8',
						},
					],
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry.stroke',
					stylers: [
						{
							color: '#edb34c',
						},
					],
				},
				{
					featureType: 'water',
					elementType: 'geometry.fill',
					stylers: [
						{
							color: '#9fc1f5',
						},
					],
				},
			],
		};
		this.map = new window.google.maps.Map(this.element, mapArgs);
	}

	createMarkers() {
		this.mapMarkers.forEach((marker) => {
			new window.google.maps.Marker({
				position: marker,
				map: this.map,
				icon: marker.icon,
			});
		});
	}

	centerMap() {
		// Create map boundaries from all map markers.
		const bounds = new window.google.maps.LatLngBounds();

		this.mapMarkers.forEach((marker) => {
			const latitudeOffset = marker.lat;
			const longitudeOffset = marker.lng;

			if (window.innerWidth >= 640) {
				bounds.extend({
					lat: latitudeOffset + 0.014,
					lng: longitudeOffset - 0.026,
				});
			} else {
				bounds.extend({
					lat: latitudeOffset + 0.01,
					lng: longitudeOffset - 0.02,
				});
			}
		});

		if (1 === this.mapMarkers.length) {
			this.map.setCenter(bounds.getCenter());
		} else {
			this.map.fitBounds(bounds);
		}
	}

	init() {
		if (
			!Object.prototype.hasOwnProperty.call(window, 'google') ||
			!Object.prototype.hasOwnProperty.call(window.google, 'maps') ||
			!Object.prototype.hasOwnProperty.call(window.google.maps, 'Map') ||
			!Object.prototype.hasOwnProperty.call(window.google.maps, 'Marker') ||
			!Object.prototype.hasOwnProperty.call(window.google.maps, 'LatLngBounds') ||
			!Object.prototype.hasOwnProperty.call(window.google.maps, 'MapTypeId') ||
			!Object.prototype.hasOwnProperty.call(window.google.maps.MapTypeId, 'ROADMAP')
		) {
			// eslint-disable-next-line no-console
			console.log("Google maps isn't available");
			return;
		}

		// before the map initialization, because during creation HTML is changed
		this.readMarkers();
		this.createMap();
		this.createMarkers();
		this.centerMap();
	}
}

class Maps {
	constructor() {
		this.isMapsLoaded = false;
		this.mapsToInit = [];

		window.googleMapsCallback = this.mapsLoadedCallback.bind(this);

		if ('loading' !== document.readyState) {
			this.setup();
		} else {
			window.addEventListener('DOMContentLoaded', this.setup.bind(this));
		}
	}

	setup() {
		const observer = new MutationObserver((records) => {
			for (const record of records) {
				record.addedNodes.forEach((addedNode) => {
					this.addListeners(addedNode);
				});
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		this.addListeners(document.body);
	}

	mapsLoadedCallback() {
		this.isMapsLoaded = true;

		this.mapsToInit.forEach((map) => {
			map.init();
		});

		this.mapsToInit = [];
	}

	addListeners(element) {
		// eslint-disable-next-line no-undef
		if (Node.ELEMENT_NODE !== element.nodeType) {
			return;
		}

		element.querySelectorAll('.google-map').forEach((mapElement) => {
			const map = new Map(mapElement);

			if (!this.isMapsLoaded) {
				this.mapsToInit.push(map);

				return;
			}

			map.init();
		});
	}
}

new Maps();
